import { FilterValues } from "../../../data-model/filterValues";
import { CmmStatus } from "../../../enums/cmmStatus";
import { DenialLetterUploadStatus } from "../../../enums/denialLetterUploadStatus";
import { TextNotesStatus } from "../../../enums/textNotesStatus";
import { convertDateToAPIFormat } from "./convertDateToApiFormat";
import { PharmaStpFileFilterKeys } from "./createFilterSections";

export interface ProcessedFilterData {
  filters: { [key: string]: string[] | null };
  dateRange?: {
    startDate: string;
    endDate: string;
  };
}

export const processFilterData = (
  validFilters: FilterValues[],
): ProcessedFilterData => {
  const filters: { [key: string]: string[] | null } = {};
  let dateRange: { startDate: string; endDate: string } | undefined;

  if (!validFilters || validFilters.length === 0) {
    return { filters };
  }

  const filter = validFilters[0];

  if (!filter || !filter.values) {
    return { filters };
  }

  Object.entries(filter.values).forEach(([filterId, filterData]) => {
    const selectedValues = filterData.values || [];

    if (selectedValues.length > 0) {
      switch (filterId) {
        case PharmaStpFileFilterKeys.BATCH:
          filters.filename = selectedValues;
          break;
        case PharmaStpFileFilterKeys.DOW:
          if (selectedValues.length >= 2) {
            dateRange = {
              startDate: convertDateToAPIFormat(selectedValues[0]),
              endDate: convertDateToAPIFormat(selectedValues[1]),
            };
          } else if (selectedValues.length === 1) {
            const convertedDate = convertDateToAPIFormat(selectedValues[0]);
            dateRange = {
              startDate: convertedDate,
              endDate: convertedDate,
            };
          }
          break;
        case PharmaStpFileFilterKeys.RESPONSE_STATUS:
          filters.response_status = selectedValues;
          break;
        case PharmaStpFileFilterKeys.SECOND_STP_STATUS:
          filters.second_stp_status = selectedValues;
          break;
        case PharmaStpFileFilterKeys.POC:
          filters.poc = selectedValues;
          break;
        case PharmaStpFileFilterKeys.SFTP_STATUS:
          filters.sftp_status = selectedValues;
          break;
        case PharmaStpFileFilterKeys.TEXT_NOTE_STATUS:
          // Convert empty strings to null in the array
          filters.text_note_status = selectedValues.map((v) =>
            v === "" ? TextNotesStatus.NOT_INITIATED : v,
          ) as any;
          break;
        case PharmaStpFileFilterKeys.LETTER_UPLOAD:
          filters["meta.denial_letter_upload_status"] = selectedValues.map(
            (v) => (v === "" ? DenialLetterUploadStatus.NOT_INITIATED : v),
          ) as any;
          break;
        case PharmaStpFileFilterKeys.CMM:
          filters["meta.cmm_st_rpa_status"] = selectedValues.map((v) =>
            v === CmmStatus.NOT_STARTED ? "" : v,
          );
          break;
        case PharmaStpFileFilterKeys.ROUTE_VIA:
          filters.route_via = selectedValues;
          break;
        default:
          break;
      }
    }
  });

  return { filters, dateRange };
};
